"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPhysicsEventQueue = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
// import { crokinolePucks } from '../entities/crokinolePucks-sidecar'
// import { crokinoleDefs } from '../main/crokinoleDefs-sidecar'
// import { crokinoleSounds } from '../sound/crokinoleSounds-sidecar'
var vecUtil_sidecar_1 = require("@lib/vecUtil-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("../simulation/minigolfMainGameGenerator-sidecar");
var minigolfSounds_sidecar_1 = require("../sound/minigolfSounds-sidecar");
var minigolfPhysics_rapier_loader_sidecar_1 = require("./minigolfPhysics_rapier_loader-sidecar");
var minigolfCreatures_1 = require("../entities/minigolfCreatures");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var namespace = 'minigolf-contact-handler';
var processPhysicsEventQueue = function (eventQueue) {
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    eventQueue.drainCollisionEvents(function (handle1, handle2, started) {
        if (minigolfDefs_sidecar_1.minigolfDefs.debugCollisions) {
            // console.log(namespace, 'collision!') // , handle1, handle2, started)
        }
        // A collision event!
        if (!started) {
            return; // TODO: needed to handle 'end' of collision
        }
        var c1 = phys.world.colliders.get(handle1);
        var c2 = phys.world.colliders.get(handle2);
        if (!c1 || !c2) {
            console.log(namespace, 'missing collider handle!', handle1, handle2, c1, c2);
            return;
        }
        var _b1 = c1.parent();
        var _b2 = c2.parent();
        if (!_b1 || !_b2) {
            console.log(namespace, 'missing rigid body!', _b1, _b2);
            return;
        }
        var _user1 = _b1 === null || _b1 === void 0 ? void 0 : _b1.userData;
        var _user2 = _b2 === null || _b2 === void 0 ? void 0 : _b2.userData;
        if (!_user1 || !_user2) {
            console.log(namespace, 'missing user data!', _user1, _user2);
            return;
        }
        var _handled = false;
        var onTypeCollision = function (t1, t2, b1, b2, cb) {
            if (_user1.type === t1 && _user2.type === t2) {
                _handled = true;
                if (minigolfDefs_sidecar_1.minigolfDefs.debugCollisions) {
                    console.log(namespace, t1 + " hit " + t2 + "!", handle1, handle2, started);
                }
                cb(b1, b2);
            }
            else if (_user1.type === t2 && _user2.type === t1) {
                _handled = true;
                if (minigolfDefs_sidecar_1.minigolfDefs.debugCollisions) {
                    console.log(namespace, t2 + " hit " + t1 + "!", handle1, handle2, started);
                }
                cb(b2, b1);
            }
        };
        onTypeCollision('creature', 'boundary', _b1, _b2, function (b1, b2) {
            var cr = minigolfCreatures_sidecar_1.minigolfCreatures.tryGetFromHandle(b1.handle);
            assert_sidecar_1.assert.notNil(cr, 'missing puck1');
            if (cr.data.isPuck || cr.data.isEnemy) {
                minigolfCreatures_sidecar_1.minigolfCreatures.tryBleedDust(cr);
                if (cr.data.isPuck) {
                    minigolfSounds_sidecar_1.minigolfSounds.playHitBlock();
                }
                else {
                    minigolfSounds_sidecar_1.minigolfSounds.playHitBlockQuiet();
                }
            }
        });
        onTypeCollision('creature', 'creature', _b1, _b2, function (b1, b2) {
            // minigolfSounds.playPieceContactsPiece()
            var puck1 = minigolfCreatures_sidecar_1.minigolfCreatures.tryGetFromHandle(b1.handle);
            assert_sidecar_1.assert.notNil(puck1, 'missing puck1');
            var creature = minigolfCreatures_sidecar_1.minigolfCreatures.tryGetFromHandle(b2.handle);
            assert_sidecar_1.assert.notNil(creature, 'missing creature');
            if (puck1.data.isParticle || creature.data.isParticle) {
                return; // no particle collision handling
            }
            if (puck1.data.isBlock && creature.data.isBlock) {
                return; // no block/block collsiions
            }
            if (puck1.data.isSpike && creature.data.isSpike) {
                return; // no block/block collsiions
            }
            var flipCollisionObjects = function () {
                // Flip to second place
                var t = creature;
                creature = puck1;
                puck1 = t;
            };
            if (puck1.data.isBreakable) {
                flipCollisionObjects();
            }
            if (creature.data.hasHealth) {
                flipCollisionObjects();
            }
            if (creature.data.isPuck) {
                flipCollisionObjects();
            }
            var soundPlayed = false;
            var cData = creature.data;
            var cState = creature.state;
            var tryPlayHitSound = function (creature, sf) {
                if (sf === void 0) { sf = null; }
                soundPlayed = true;
                var soundFunc = sf;
                if (!soundFunc) {
                    if (creature.data.contactSounds.length > 0) {
                        soundFunc = rando_sidecar_1.rando.sample(creature.data.contactSounds);
                    }
                }
                if (soundFunc) {
                    soundFunc();
                }
            };
            var tryPlayHitSoundFromGroup = function (sfs) {
                if (sfs === void 0) { sfs = []; }
                soundPlayed = true;
                var soundFunc = null;
                if (sfs.length > 0) {
                    soundFunc = rando_sidecar_1.rando.sample(sfs);
                }
                if (soundFunc) {
                    soundFunc();
                }
            };
            // --- anyone contacts
            if (puck1.data.canBreakCrates && cData.isBreakable) {
                cState.health -= 1;
                minigolfCreatures_sidecar_1.minigolfCreatures.tryBleed(creature);
                if (cState.health <= 0) {
                    if (!minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(creature, 'doom')) {
                        minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(creature, {
                            timeLeft: 0.05,
                            type: 'doom',
                            vec: vecUtil_sidecar_1.vecUtil.create(0, 1),
                        });
                    }
                    tryPlayHitSound(creature, minigolfSounds_sidecar_1.minigolfSounds.playCrateBroke);
                }
                else {
                    tryPlayHitSound(creature);
                }
            }
            // Other creatures should be hurt by spikes
            if (cData.isSpike) {
                minigolfCreatures_sidecar_1.minigolfCreatures.hurt(puck1, 1, 'spiked', true);
                tryPlayHitSound(creature);
            }
            if (cData.isBlock) {
                minigolfCreatures_sidecar_1.minigolfCreatures.tryBleedDust(puck1);
            }
            // --- only puck contacts after this
            if (!puck1.data.isPuck) {
                // creature vs creature or block
                if (puck1.data.isAffectedBySlopes && creature.data.isBlock) {
                    minigolfSounds_sidecar_1.minigolfSounds.playHitBlockQuiet();
                }
                else if (puck1.data.isAffectedBySlopes &&
                    creature.data.isAffectedBySlopes) {
                    minigolfSounds_sidecar_1.minigolfSounds.playHitBlockQuiet();
                }
                return; // Only pucks can hit creatures
            }
            if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health <= 0 &&
                !minigolfDefs_sidecar_1.minigolfDefs.debug_disallowDeath) {
                return;
            }
            // if (cData.creatureType === 'ghost') {
            //   soundPlayed = true // No sound yet
            //   // minigolfCreatures.flingPuckRandomly(puck1, 0.03)
            //   // console.log('hit ghost!') // TODO: use intersection instead to slowly fling puck like going through jelly
            // }
            // if (cData.isTrap) {
            //   soundPlayed = true
            // }
            // if (cData.creatureType === 'slope') {
            //   soundPlayed = true
            // }
            if (cData.creatureType === 'lock') {
                if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.keys > 0) {
                    if (!minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(creature, 'doom')) {
                        minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(creature, {
                            timeLeft: 0.05,
                            type: 'doom',
                            vec: vecUtil_sidecar_1.vecUtil.create(0, 1),
                        });
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.keys -= 1;
                        tryPlayHitSound(creature, minigolfSounds_sidecar_1.minigolfSounds.playUnlock);
                    }
                    // minigolfCreatures.kill(creature)
                    // Play unlock sound
                    // minigolfSounds.playPieceContactsPole()
                }
                else {
                    tryPlayHitSound(creature);
                }
            }
            if (cData.creatureType === 'blob') {
                // minigolfCreatures.flingPuckRandomly(puck1, 1)
                // Find our normal
                var delta = vecUtil_sidecar_1.vecUtil.deltaTowardsXY(creature.rigidBody.translation(), puck1.rigidBody.translation(), 1);
                delta = vecUtil_sidecar_1.vecUtil.normalizeSafe(delta);
                delta = vecUtil_sidecar_1.vecUtil.scale(delta, 1);
                // Fling in that direction
                puck1.rigidBody.applyImpulse(delta, true);
            }
            if (cData.hasHealth) {
                if (minigolfGameState_sidecar_1.minigolfGameState.isPlayersTurn()) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.hurt(creature, minigolfGameState_sidecar_1.minigolfGameState.get().playerState.attackPower, 'player');
                    tryPlayHitSound(creature);
                }
                else {
                    if (cState.health > 0) {
                        if (creature.data.damageMessage) {
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.lastDamage =
                                creature.data.damageMessage;
                        }
                        else {
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.lastDamage = 'unknown enemy';
                        }
                        minigolfCreatures_sidecar_1.minigolfCreatures.hurt(puck1, 1, creature.data.damageMessage); // Based on creature?
                        tryPlayHitSoundFromGroup(creature.data.hitBySounds);
                    }
                }
            }
            if (cData.pickupType) {
                soundPlayed = true;
                var doKill = true;
                if (cData.pickupType === 'health') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health += 1;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+health');
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'health2') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health += 2;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+health');
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'food') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food += 1;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+food');
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'sword') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.attackPower += 1;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+attack');
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'key') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.keys += 1;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+key');
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'stairs-down') {
                    doKill = false;
                    tryPlayHitSound(creature, minigolfSounds_sidecar_1.minigolfSounds.playHitStairsDown);
                    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                    minigolfCreatures_1.tryBleedStars(puck1);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel += 1;
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food -= 1; // Offset free move
                    if (cState.tag) {
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.difficulty = cState.tag;
                        if (cState.tag === 'easy') {
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food = 6;
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health = 9;
                        }
                        if (cState.tag === 'normal') {
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food = 4;
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health = 6;
                        }
                        if (cState.tag === 'hard') {
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food = 2;
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health = 3;
                        }
                    }
                }
                if (cData.pickupType === 'stairs-up') {
                    if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.hasAmulet) {
                        doKill = false;
                        tryPlayHitSound(creature, minigolfSounds_sidecar_1.minigolfSounds.playHitStairsDown);
                        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel += 1;
                        // Win!
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.didWin = true;
                        minigolfCreatures_1.tryBleedStars(puck1);
                        minigolfCreatures_1.tryBleedStars(puck1);
                        minigolfCreatures_1.tryBleedStars(puck1);
                        minigolfCreatures_1.tryBleedStars(puck1);
                    }
                    else {
                        // No amulet!
                        tryPlayHitSound(creature, minigolfSounds_sidecar_1.minigolfSounds.playHitBlock);
                        doKill = false;
                    }
                }
                if (cData.pickupType === 'amulet') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.hasAmulet = true;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+amulet');
                    minigolfCreatures_1.tryBleedStars(puck1);
                    minigolfCreatures_1.tryBleedStars(puck1);
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'money') {
                    tryPlayHitSound(creature);
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.money += 1;
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(creature, '+$');
                    minigolfCreatures_1.tryBleedStars(puck1);
                    minigolfCreatures_1.tryBleedStars(puck1);
                }
                if (cData.pickupType === 'web') {
                    tryPlayHitSound(creature);
                    minigolfCreatures_1.tryBleed(puck1, 'spectral');
                    minigolfCreatures_sidecar_1.minigolfCreatures.stop(puck1);
                    minigolfCreatures_sidecar_1.minigolfCreatures.say(puck1, 'stuck');
                }
                // Kill our pickup!
                if (doKill) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.kill(creature);
                }
            }
            if (!soundPlayed) {
                tryPlayHitSound(creature);
                // soundPlayed = true
                // minigolfSounds.playPieceContactsBoundary()
            }
            // minigolfMainGameGenerator.signal_newLevel()
        });
        if (!_handled) {
            console.log('unhandled collision between', _user1.type, _user2.type);
        }
    });
};
exports.processPhysicsEventQueue = processPhysicsEventQueue;
